import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth, landingPathFor } from "./AuthContext";

export function RequireAuth({ children, adminOnly = false }: { children: ReactNode; adminOnly?: boolean }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return <div className="loading" style={{ padding: "2rem" }}>Verificando sesión…</div>;
  }
  if (status === "anon" || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // El comercial sólo puede ver la sección de comisiones; cualquier otra ruta
  // lo devuelve a su página inicial.
  if (user.role === "comercial" && !location.pathname.startsWith("/comisiones")) {
    return <Navigate to={landingPathFor(user.role)} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to={landingPathFor(user.role)} replace />;
  }
  return <>{children}</>;
}
